import { render, staticRenderFns } from "./ClueAttachment.vue?vue&type=template&id=1829e8eb&"
import script from "./ClueAttachment.vue?vue&type=script&lang=js&"
export * from "./ClueAttachment.vue?vue&type=script&lang=js&"
import style0 from "./ClueAttachment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports